'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rating = require('./components/Rating.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rating).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/rating/lib/index.js
// module id = 1010
// module chunks = 4